import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Features from "../components/Features";
import HowItWorks from "../components/HowItWorks";
import Shopping from "../components/Shopping";
import AppDownload from "../components/AppDownload";
import About from "../components/About";
import ContactSection from "../components/ContactSection";

export default function HomePage() {
    return (
        <main>
            <Hero />
            <Marquee />
            <Features />
            <HowItWorks />
            <Shopping />
            <AppDownload />
            <About />
            <ContactSection />
        </main>
    );
}
